var _style, _path, _path2, _defs, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThyroid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B72A5C;}\n\t.st1{fill:#F8A087;}\n\t.st2{clip-path:url(#SVGID_00000155132729516470201850000003160186821672730264_);}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.6512;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,32.8c0,0,4.6-5.6,9.3,0.3s8,19.4,10.7,18.9c2.8-0.6,1.6-12,7.4-12s3.9,12,7.4,12c3.5,0,7-21.5,15.6-21.5 s9.3,16.6,8.4,23.2c-0.9,6.7-5.6,30.8-16,31.4c-10.4,0.6-0.1-13.1-15.4-13.1s-5.2,13.1-15.4,13.1S26.2,60.7,25.2,52.2 C24.2,43.8,26.5,37.1,29.6,32.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M29.6,32.8c0,0,4.6-5.6,9.3,0.3s8,19.4,10.7,18.9c2.8-0.6,1.6-12,7.4-12s3.9,12,7.4,12 c3.5,0,7-21.5,15.6-21.5s9.3,16.6,8.4,23.2c-0.9,6.7-5.6,30.8-16,31.4c-10.4,0.6-0.1-13.1-15.4-13.1s-5.2,13.1-15.4,13.1 S26.2,60.7,25.2,52.2C24.2,43.8,26.5,37.1,29.6,32.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088813092682996829520000000757015742109719223_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088813092682996829520000000757015742109719223_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1,34.3c0,0,7.1,2.4,8.4,5.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.6,47.9c0,0,8.4-3.6,15.8,0.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.5,35.2c0,0-7.5,3.1-8.2,11.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.5,41.8c0,0-8.5,5.9-3.7,15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24,52c0,0,10-0.1,13.7,6.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.8,61.4c0,0,5.9,1.4,11.8,5.1c6,3.6-5.5,12.1-5.5,12.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.3,48.4c0,0-4.6,10.6,3.7,13.9c0,0,0.7,7,4.1,10.2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33,64c0,0,3.6-7.1,12.9-8.6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.3,68.9c0,0,3.9-8,7.9-9.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.3,67.8c0,0-8.1,2.8-13,1.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.1,83.5c0,0-0.9-3.5-3.4-6C41.2,75,42.5,70,42.5,70"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51,62.3c0,0,6.9-5.6-0.4-13.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.1,45.4c0,0,6.5,1.2,10.6,4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.1,72.5c0,0,4.1-3,4.9-11.1c0.8-8.2,3-10.4,3-10.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.7,53.8c0,0,3.2,3.5,8.6,5.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.3,46.6c0,0,5,4.9,2.7,11.5c-2.3,6.6-8.4,5.7-8.4,5.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.4,32.7c0,0,6.7,3.9,6.8,7.1c0.1,3.2-4.9,8.8,8.4,13.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.3,41.6c0,0,8.5,2.9,8.3,14.5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,39.8c0,0,3.4-5.8,6-5.9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.7,49.2c0,0,1.8-3.2,3.6-3.9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.8,54.4c0,0,7.3,0.5,9.7,3.3c0,0,3,5.9,6.6,8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.4,62c0,0,5.3,7-4.5,11.2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.8,65.8c0,0,4.8,1,7.2-1.3c2.4-2.3,4.5-6.8,4.5-6.8s3.5-3.9,8.4-4.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.6,65.3c-0.7,9.7-8.7,13.7-8.7,13.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.7,82.4c0,0-2.1-7.1-7-10.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76,64.5c0,0,8.3,5.7,8,10.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThyroid);
export default __webpack_public_path__ + "static/media/Thyroid.6bfbc2756ebfafd51030e9824773251c.svg";
export { ForwardRef as ReactComponent };